import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from '@mantine/core';
import LayoutWrapper from '@/components/LayoutWrapper';
import Title from './Title';
import Menu from './Menu';
import Extra from './Extra';
import Head from './Head';
import Actions from './Actions';
import Box from '../Box';
import classes from './page.module.css';

const Page = (props) => {
  const {
    children,
    title,
    subTitle,
    subtitle,
    side,
    sideSize = 'md',
    actions,
    maxWidth = 'lg',
    menu = [],
    menuSize = 'md',
    extra,
    extraSize = 'md',
  } = props;

  const resolvedSubtitle = subtitle ?? subTitle;

  const sideClasses = clsx(classes.side, sideSize && classes[sideSize]);
  const contentClasses = clsx(classes.content, sideSize && classes[sideSize]);
  const bodyClasses = clsx(classes.body, maxWidth && classes[maxWidth]);
  const actionClasses = clsx(classes.actions, maxWidth && classes[maxWidth]);

  const legacyBody =
    children ? (
      <div className={bodyClasses}>
        {!Title && title && <Text className={classes.title}>{title}</Text>}
        {!Title && resolvedSubtitle && <Text className={classes.subTitle}>{resolvedSubtitle}</Text>}
        {children}
      </div>
    ) : null;

  const actionsElement = actions ? <div className={actionClasses}>{actions}</div> : null;
  const sideElement = side ? <div className={sideClasses}>{side}</div> : null;

  return (
    <div className={classes.page}>
      <LayoutWrapper sideSize={sideSize}>
        <div className={classes.container}>
          {sideElement}  {/* 👈 עכשיו חלק מהגריד/פלקס של container */}
          {Array.isArray(menu) && menu.length > 0 ? (
            <Menu data={menu} size={menuSize} />
          ) : null}

          <div className={contentClasses}>
            {legacyBody || children}
            {actionsElement}
          </div>

          {extra ? <Extra size={extraSize}>{extra}</Extra> : null}
        </div>
      </LayoutWrapper>
    </div>
  );
};

Page.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // ישן
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // חדש
  side: PropTypes.node,
  sideSize: PropTypes.oneOf(['sm', 'md', 'lg']),
  actions: PropTypes.node,
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),
  menu: PropTypes.array,
  menuSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  extra: PropTypes.node,
  extraSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

Page.Head = Head;
Page.Section = Box;
Page.Actions = Actions;

export default Page;
